import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.css';
import App from './Components/App'

const container = document.getElementById('root')

ReactDOM.render(<App/>,container)